import React, { SyntheticEvent } from 'react';
import { GoogleButton } from '@zapier/auth';
import { addParamsToUrl } from '@zapier/common-utils';

type GoogleSSOButtonProps = {
  /** True to make button blue */
  isBlue?: boolean;

  /** True to make button large */
  isLarge?: boolean;

  /** Button Text */
  label: string;

  onClick?: (
    e: SyntheticEvent<HTMLAnchorElement>,
    href: string | undefined
  ) => any;

  /** Query params to be added to url */
  queryParams?: {};
};
const defaultProps = {
  label: 'Sign Up With Google',
  queryParams: {},
};

const GoogleSSOButton: React.FC<GoogleSSOButtonProps> = props => {
  const href = addParamsToUrl(
    '/google-sso/start',
    {
      scopes: 'basic',
      ...props.queryParams,
    },
    true
  );
  return (
    <GoogleButton
      href={href}
      isBlue={props.isBlue}
      isLarge={props.isLarge}
      label={props.label}
      onClick={e => props.onClick && props.onClick(e, href)}
    />
  );
};

GoogleSSOButton.defaultProps = defaultProps;
export default GoogleSSOButton;
